import { Model } from "./model";

export class MediaModel extends Model {
  /**
   * The file name of the media.
   */
  filename?: string;

  /**
   * The id of the model
   */
  id?: string;

  /**
   * The media of the model.
   */
  _media?: MediaModel[] | undefined;

  get media(): MediaModel[] | undefined {
    return this._media;
  }

  set media(value) {
    this._media = value?.map((media) => new MediaModel(media));
  }

  /**
   * Meta data of the model.
   */
  meta?: {
    id?: string;
    width?: number;
    height?: number;
  };

  /**
   * The mime type of the media.
   */
  mimetype?: string;

  /**
   * The poster of the model.
   */
  get poster(): MediaModel | void {
    if (this.media && this.media.length) {
      return this.media.find((m) => m.type === "poster");
    }

    return;
  }

  /**
   * The sizes of the media.
   */
  sizes?: any;

  /**
   * The type of the media.
   */
  type?: string;

  /**
   * The link to the media.
   */
  url?: string;
}
